import type { FaireProductEntity } from "../../entity_types/product";

export const p_7vjhdjw7rj: FaireProductEntity = {
  token: "p_7vjhdjw7rj",
  type: "product",
  name: "Knotte Ring | Chunky Knot Design Double Line Band",
  brandToken: "b_493edh35w5",
  brandName: "MOND HAUS",
  imageUrl:
    "https://cdn.faire.com/fastly/bfad6219fe0b68acc2baf6bf0e9e61f16507d8c0dcae98dbf2b6a7d4380a2ded.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/898de72eed3d13eb9bef84a821aa547c5bfdb236118eedab1493227424072ec0.jpeg",
    "https://cdn.faire.com/fastly/be2a0fcb6127defb7b3e1464302ef4e4339313eb930c21d0e33e3ca0b81824b5.jpeg",
    "https://cdn.faire.com/fastly/eae4560f31ec23f8ea54d6da2b27e65ddf3d4d1fa78f2c95cd0f08285c7d5204.jpeg",
  ],
  priceDollars: 5.55,
  description:
    "Get ready to rock the latest trend with a Knotte statement ring featuring a chunky knot detail. This bold and edgy design is available in one size(US6.5), so make sure it fits before you purchase it!\n\nThe welding mark on the double line band is a natural occurrence during the crafting process. Please note that this is not a defect and cannot be returned. We hope you understand and appreciate the charm's uniqueness.\n\n- Nickel-free plated brass\n- Size: US 6.5",
  tags: [],
  msrpDollars: 11.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:51.481Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
